import ObjectiveContributors from './ObjectiveContributors';

export default ObjectiveContributors;
